import React from 'react';

import { ReactComponent as IconEdit } from './svg/iconEdit.svg';
import { ReactComponent as IconCopy } from './svg/iconClone.svg';
import { ReactComponent as IconDelete } from './svg/iconDelete.svg';
import { ReactComponent as IconPublish } from './svg/iconPublish.svg';

import { TColumn, TCellRenderTemplate } from 'types/columnDefs';
import { TActionsProps } from 'types/gridDefs';

import { ActionsButton } from './Actions.Button';

/* ======================================== */

const iconSize = 22;        // TODO theme
const iconMargin = 8;

/* ======================================== */

/**
 * calculate the width of the Actions column - looks better to be fixed with
 * @private
 */
const ActionColumnWidth = (props: TActionsProps) => {
    const numIcons = [props.onRowEdit, props.onRowCopy, props.onRowDelete, props.onRowPublish].filter(callback => callback).length;
    // for each icon: width + 6 left margin + 6 right margin
    // for the cell: 7 left margin, 7 right margin
    return numIcons * (iconSize + iconMargin * 2 + 2);
};

/**
 * generate the custom cell render component for the Actions column - may contain multiple action buttons
 * @private
 */
const RenderActionButtons = (props: TActionsProps) => {
    const cellRender = (template: TCellRenderTemplate) => {
        return (
            <span>
                <ActionsButton
                    disabled={!(template.data?.allowEdit) || !props.enableActions}
                    callback={props.onRowEdit}
                    rowData={template.data}
                    icon={IconEdit}
                />
                <ActionsButton
                    disabled={!(template.data?.allowCopy) || !props.enableActions}
                    callback={props.onRowCopy}
                    rowData={template.data}
                    icon={IconCopy}
                />
                <ActionsButton
                    disabled={!(template.data?.allowDelete) || !props.enableActions}
                    callback={props.onRowDelete}
                    rowData={template.data}
                    icon={IconDelete}
                />
                <ActionsButton
                    disabled={!(template.data?.allowPublish) || !props.enableActions}
                    callback={props.onRowPublish}
                    rowData={template.data}
                    icon={IconPublish}
                />
            </span>
        );
    };

    return cellRender;
};

/* ======================================== */

/**
 * Generate the full specification for the Actions column
 * @private
 */
export const GetActionsColumn = (props: TActionsProps): TColumn => ({
    field: 'action',
    type: 'object',
    alignment: 'center',
    caption: 'Actions',     // TODO localise
    cssClass: 'dx-actions',
    width: ActionColumnWidth(props),
    minWidth: 100,          // allows the full caption to be visible
    hidingPriority: 99,
    cellRender: RenderActionButtons(props)
});
